function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.stBurger{stroke:#000000;stroke-width:0.25;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "burger",
  transform: "translate(0.138 -72.886)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2388",
  transform: "translate(13.493 79.234)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2387",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_73",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2390",
  transform: "translate(16.132 75.934)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2389"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_74",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2392",
  transform: "translate(15.406 74.219)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2391",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_75",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2394",
  transform: "translate(17.452 79.234)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2393",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_76",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2396",
  transform: "translate(15.472 81.873)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2395",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_77",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2398",
  transform: "translate(21.411 81.213)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2397",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_78",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2400",
  transform: "translate(19.233 75.275)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2399",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_79",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2402",
  transform: "translate(20.091 77.254)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2401",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_80",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2404",
  transform: "translate(22.796 75.934)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2403"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_81",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2406",
  transform: "translate(22.796 78.574)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2405",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_82",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2408",
  transform: "translate(6.3 79.893)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2407"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_83",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2410",
  transform: "translate(7.62 77.254)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2409",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_84",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2412",
  transform: "translate(12.899 74.615)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2411",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_85",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2414",
  transform: "translate(11.579 80.553)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2413",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_86",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2416",
  transform: "translate(24.116 80.553)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2415",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_87",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2418",
  transform: "translate(14.152 77.254)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2417",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_88",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2420",
  transform: "translate(10.853 75.868)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2419"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_89",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2422",
  transform: "translate(9.534 78.574)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2421",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_90",
  className: "stBurger",
  cx: 0.5,
  cy: 0.5,
  r: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2424",
  transform: "translate(0.001 73.011)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2423",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_3614",
  className: "stBurger",
  d: "M33.6,10.5c-0.3-0.6-1-1-1.7-1c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5 c0.3,0,0.7,0.2,0.8,0.4c0.1,0.3,0.1,0.6-0.1,0.9l0,0c-0.3,0.5-0.7,0.9-1.2,1.3c-0.3,0.2-0.6,0.4-1,0.5c-0.6,0.3-1.3,0.4-1.9,0.4 c-0.1,0-0.3,0-0.4,0c-0.7-0.1-1.3,0-2,0.2c-0.6,0.2-1.1,0.6-1.5,1.2c-0.7,0.9-1.6,1.5-2.7,1.6c-1.1,0.2-2.2,0-3.2-0.5 c-1.1-0.7-2.6-0.7-3.7,0c-1,0.6-2.1,0.8-3.2,0.5c-1.1-0.2-2.1-0.8-2.7-1.6c-0.4-0.5-0.9-1-1.5-1.2C7,14,6.3,13.9,5.6,14 c-0.1,0-0.3,0-0.4,0c-0.7,0-1.3-0.1-1.9-0.4c-0.3-0.1-0.7-0.3-1-0.5c-0.5-0.3-0.9-0.8-1.2-1.3l0,0C1,11.6,0.9,11.3,1.1,11 c0.2-0.3,0.5-0.5,0.8-0.4h0H2c0.5,0,0.9,0.1,1.4,0.2c0.4,0.9,1.2,1.7,2.1,2c7.3,2.7,15.3,2.7,22.6,0c1-0.4,1.9-1.2,2.2-2.2 c0.3-0.8,0.2-1.8-0.2-2.6c-2.6-5-7.8-8.1-13.4-8c-2.8,0-5.6,0.7-8,2.2C6.6,3.5,4.8,5.5,3.6,7.8C3.5,8,3.4,8.1,3.4,8.3 C3.4,8.6,3.5,8.9,3.8,8.9s0.5-0.1,0.6-0.4c0,0,0,0,0,0c0-0.1,0-0.2,0.1-0.3C6.9,3.7,11.7,0.9,16.9,1c4.1,0,8,1.7,10.7,4.7 c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7c0.2,0.2,0.5,0.2,0.7,0c0.1-0.2,0.2-0.4,0-0.6c0.7,0.8,1.3,1.7,1.7,2.6 c0.3,0.6,0.3,1.2,0.1,1.8c-0.3,0.8-0.9,1.4-1.6,1.6c-7.1,2.6-14.8,2.6-21.9,0c-0.8-0.3-1.4-0.9-1.6-1.6v0c0,0,0,0,0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0C3.4,9.7,2.7,9.6,2.1,9.6h0H1.9h0c-0.7,0-1.3,0.4-1.7,1 c-0.3,0.6-0.3,1.3,0.1,1.9l0,0c0.4,0.6,0.9,1.1,1.5,1.6c0.2,0.1,0.4,0.3,0.6,0.4c-0.1,0.2-0.2,0.5-0.2,0.7c0,1.5,0.9,2.8,2.2,3.4 C4,20.2,4.9,22,6.6,22.7c3.3,1.4,6.9,1.5,10.3,1.5s7.1-0.1,10.3-1.5c1.1-0.5,1.9-1.4,2.1-2.5c0.1-0.3-0.1-0.5-0.4-0.6 c-0.3-0.1-0.5,0.1-0.6,0.4c0,0,0,0,0,0c-0.2,0.8-0.8,1.5-1.5,1.9c-2.5,1-5.2,1.4-7.9,1.4l3.3-2.8c2.3-0.3,4.5-0.9,6.6-1.7l0.1,0 c1.5-0.5,2.6-1.9,2.6-3.5c0-0.3-0.1-0.5-0.2-0.7c0.2-0.1,0.4-0.2,0.6-0.4c0.6-0.4,1.1-0.9,1.5-1.6l0,0 C33.8,11.9,33.9,11.1,33.6,10.5z M6.9,21.7c-1.1-0.5-1.8-1.7-1.6-2.9c2,0.7,4,1.2,6.1,1.5l3.3,2.8C12.1,23.2,9.4,22.7,6.9,21.7z  M28.6,17.7L28.6,17.7c-1.6,0.6-3.2,1-4.8,1.4l0.9-0.7c0.2-0.2,0.2-0.5,0.1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1l-2.3,1.9l0,0L18,22.6 c-0.6,0.6-1.7,0.6-2.3,0L12,19.5l0,0l-2.5-2.1c-0.2-0.2-0.5-0.1-0.7,0.1c-0.2,0.2-0.1,0.5,0.1,0.7l1.1,0.9 c-1.6-0.3-3.2-0.8-4.7-1.4l-0.1,0c-1.1-0.4-1.9-1.4-1.9-2.6c0-0.1,0-0.2,0.1-0.3c0.6,0.2,1.3,0.3,2,0.3c0.2,0,0.4,0,0.5-0.1 c0.5-0.1,1,0,1.4,0.2C7.7,15.3,8,15.6,8.3,16c0.8,1.1,2,1.8,3.3,2.1c1.3,0.3,2.7,0,3.9-0.7c0.8-0.5,1.8-0.5,2.6,0 c0.8,0.5,1.8,0.8,2.8,0.8c0.4,0,0.7,0,1.1-0.1c1.3-0.2,2.5-1,3.3-2.1c0.3-0.4,0.6-0.7,1.1-0.8c0.5-0.2,0.9-0.2,1.4-0.2 c0.2,0,0.4,0.1,0.5,0.1c0.7,0,1.3-0.1,2-0.3c0.1,0.1,0.1,0.2,0.1,0.3C30.5,16.3,29.8,17.3,28.6,17.7z"
}))));

function SvgBurguer01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 24.4",
    style: {
      enableBackground: "new 0 0 34 24.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurguer01);
export default __webpack_public_path__ + "static/media/burguer-01.75f51753.svg";
export { ForwardRef as ReactComponent };